import {
  getSignsStart,
  getSignsSuccess,
  getSignsFailure,
  getSignImagesStart,
  getSignImagesSuccess,
  getSignImagesFailure,
  getGPSDataStart,
  getGPSDataSuccess,
  getGPSDataFailure,
  getEventsStart,
  getEventsSuccess,
  getEventsFailure,
  removeEventStart,
  removeEventSuccess,
  removeEventFailure,
  changeSignStart,
  changeSignSuccess,
  changeSignFailure,
  repositionSignsStart,
  repositionSignsSuccess,
  repositionSignsFailure,
  editDriveNameStart,
  editDriveNameSuccess,
  editDriveNameFailure,
  getNearestGPSDataStart,
  getNearestGPSDataSuccess,
  getNearestGPSDataFailure,
  clearNearestGPSData,
  addNewSignStart,
  addNewSignSuccess,
  addNewSignFailure,
  clearNewSign,
  resetEventsState,
  getImageUrlStart,
  getImageUrlSuccess,
  getImageUrlFailure,
  resetImageUrlState,
} from './dashboard.slice';
import {
  fetchSignsApi,
  fetchSignImagesApi,
  fetchGPSApi,
  fetchEventsApi,
  deleteSignFromDriveApi,
  changeSignApi,
  repositionSignsApi,
  editDriveNameApi,
  getNearestGpsDataApi,
  addNewSignApi,
  fetchSelectedEventImageUrlApi,
} from '../api/dashboard.api';

export const fetchSigns = () => async (dispatch, getState) => {
  const { signs, lastFetched } = getState().dashboard;
  const cacheTimeout = 3600000;

  if (signs?.length > 0 && lastFetched && Date.now() - lastFetched < cacheTimeout) {
    return;
  }

  dispatch(getSignsStart());
  try {
    const response = await fetchSignsApi();
    dispatch(getSignsSuccess(response.data));
  } catch (error) {
    dispatch(getSignsFailure(error.response.data));
  }
};

export const fetchSignImages = (signCodes) => async (dispatch) => {
  dispatch(getSignImagesStart());
  try {
    const response = await fetchSignImagesApi(signCodes);
    dispatch(getSignImagesSuccess(response.data));
  } catch (error) {
    dispatch(getSignImagesFailure(error.response.data));
  }
};

export const fetchGPSData = (drive_id) => async (dispatch) => {
  dispatch(getGPSDataStart());
  try {
    const response = await fetchGPSApi(drive_id);
    dispatch(getGPSDataSuccess(response));
  } catch (error) {
    dispatch(getGPSDataFailure(error.response.data));
  }
};

export const fetchEvents = (drive_id, signal) => async (dispatch) => {
  dispatch(getEventsStart());

  let cursor = null;
  const allEvents = [];

  try {
    // eslint-disable-next-line no-constant-condition
    while (true) {
      if (signal.aborted) {
        throw new DOMException('Aborted', 'AbortError');
      }
      const response = await fetchEventsApi({
        driveId: drive_id,
        limit: 100,
        cursor,
        signal,
      });
      const { events, nextCursor } = response.data;
      if (!events || events.length === 0) break;

      allEvents.push(...events);
      cursor = nextCursor;

      if (!nextCursor) break;
    }
    dispatch(getEventsSuccess({ data: allEvents }));
  } catch (error) {
    if (
      error.code === 'ERR_CANCELED' ||
      error.name === 'CanceledError' ||
      error.name === 'AbortError'
    ) {
      return;
    }
    dispatch(getEventsFailure(error.response.data));
  }
};

export const fetchSelectedEventImageUrl = (eventId) => async (dispatch) => {
  dispatch(getImageUrlStart());
  try {
    const response = await fetchSelectedEventImageUrlApi(eventId);
    dispatch(getImageUrlSuccess(response.data));
  } catch (error) {
    dispatch(getImageUrlFailure(error.response.data));
  }
};

export const resetEventImageUrlState = () => async (dispatch) => {
  dispatch(resetImageUrlState());
};

export const deleteEvent = (driveid, eventid) => async (dispatch) => {
  dispatch(removeEventStart());
  try {
    const response = await deleteSignFromDriveApi(driveid, eventid);
    dispatch(removeEventSuccess());
    return response.data;
  } catch (error) {
    dispatch(removeEventFailure(error.response.data));
  }
};

export const changeEvent = (driveid, eventid, signname, signcode, signtype) => async (dispatch) => {
  dispatch(changeSignStart());
  try {
    const response = await changeSignApi(driveid, eventid, signname, signcode, signtype);
    dispatch(changeSignSuccess());
    return response.data;
  } catch (error) {
    dispatch(changeSignFailure(error.response.data));
  }
};

export const repositionSigns = (driveid, repositionedSigns) => async (dispatch) => {
  dispatch(repositionSignsStart());
  try {
    const response = await repositionSignsApi(driveid, repositionedSigns);
    dispatch(repositionSignsSuccess());
    return response.data;
  } catch (error) {
    dispatch(repositionSignsFailure(error.response.data));
  }
};

export const editDriveName = (driveId, driveName) => async (dispatch) => {
  dispatch(editDriveNameStart());
  try {
    const response = await editDriveNameApi(driveId, driveName);
    dispatch(editDriveNameSuccess());
    return response.data;
  } catch (error) {
    dispatch(editDriveNameFailure(error.response.data));
  }
};

export const getNearestGPSData = (driveid, timestamp) => async (dispatch) => {
  dispatch(getNearestGPSDataStart());
  try {
    const response = await getNearestGpsDataApi(driveid, timestamp);
    dispatch(getNearestGPSDataSuccess(response.data));
  } catch (error) {
    dispatch(getNearestGPSDataFailure(error.response.data));
  }
};

export const resetNearestGPSRecord = () => (dispatch) => {
  dispatch(clearNearestGPSData());
};

export const addNewEvent = (request) => async (dispatch) => {
  dispatch(addNewSignStart());
  try {
    const response = await addNewSignApi(request);
    dispatch(addNewSignSuccess(response.data));
    return response.data;
  } catch (error) {
    dispatch(addNewSignFailure(error.response.data));
  }
};

export const resetNewSignData = () => (dispatch) => {
  dispatch(clearNewSign());
};

export const resetEventsStateData = () => (dispatch) => {
  dispatch(resetEventsState());
};
